import React, { useState, useEffect, useCallback, useRef } from "react";

import Typography from "@mui/material/Typography";
import { getTreemapData } from "../Service/data";

import { CircularProgress } from "@mui/material";

import { useTheme } from "@mui/material/styles";
import Treemap from "../Charts/Treemap";

import Stack from "@mui/material/Stack";

import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from "@mui/material";

const TreemapCharts = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [noData, setNoData] = useState(true);

  const theme = useTheme();

  const [selectedValues, setSelectedValues] = useState([]);
  const checkboxValues = ["1d", "5d", "1m", "3m", "YTD"];

  const handleCheckboxChange = (event) => {
    const value = event.target.name;
    setSelectedValues((prevSelectedValues) =>
      prevSelectedValues.includes(value)
        ? prevSelectedValues.filter((item) => item !== value)
        : [...prevSelectedValues, value]
    );
  };

  useEffect(() => {
    getTreemapData().then((data) => {
      setData(data);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    if (data !== undefined && data !== null && data.length > 0) {
      setLoading(false);
      setNoData(false);
    }
  }, [data]);

  return (
    <div style={{ minHeight: "400px" }}>
      <Typography
        variant="h5"
        sx={{
          color: theme.palette.text.primary,
        }}
      >
        Treemap Charts
      </Typography>
      <FormControl component="fieldset">
        <FormLabel component="legend">Select Time Periods</FormLabel>
        <FormGroup>
          <Stack direction={"row"} spacing={2}>
            {checkboxValues.map((value) => (
              <FormControlLabel
                key={value}
                control={
                  <Checkbox
                    checked={selectedValues.includes(value)}
                    onChange={handleCheckboxChange}
                    name={value}
                  />
                }
                label={value}
              />
            ))}
          </Stack>
        </FormGroup>
      </FormControl>
      {loading && <CircularProgress />}
      {noData ? (
        <Typography>No data was received</Typography>
      ) : (
        <div>
          {data.map((item, index) => (
            <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
              {selectedValues.map((value, index) => (
                <div key={`${value}_${index}_${item.name}`}>
                  <Typography color={theme.palette.text.primary}>
                    {item.name} {value}
                  </Typography>
                  <div key={index} style={{ margin: "10px" }}>
                    <Treemap
                      data={item}
                      time={value}
                      width={1200}
                      height={900}
                    ></Treemap>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TreemapCharts;
